var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrainguide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.094 10.044h-1.182v23.047h1.182V10.044zM27.533 18.443a2.365 2.365 0 0 0-2.11-.893l-.13-1.146a3.547 3.547 0 0 1 3.186 1.347l-.946.692z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.096 18.606v-1.153c1.276 0 2.315-1.013 2.315-2.257h1.183c0 1.881-1.569 3.41-3.498 3.41zM15.466 18.443l-.945-.692a3.547 3.547 0 0 1 3.186-1.347l-.13 1.146a2.35 2.35 0 0 0-2.11.893z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.904 18.606c-1.93 0-3.498-1.529-3.498-3.41h1.183c0 1.244 1.039 2.257 2.315 2.257v1.153zM26.488 25.688h-1.183c0-1.201.66-2.33 1.724-2.943l.598.995a2.249 2.249 0 0 0-1.14 1.948z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.594 26.392H25.41c0-1.244-1.039-2.257-2.315-2.257v-1.153c1.93 0 3.498 1.529 3.498 3.41zM28.398 28.322l-.024-1.639a2.986 2.986 0 0 0 2.912-2.524 2.947 2.947 0 0 0-2.458-3.386 2.963 2.963 0 0 0-2.726 1.025l-1.294-1.043a4.653 4.653 0 0 1 4.275-1.596 4.57 4.57 0 0 1 3.037 1.838 4.533 4.533 0 0 1 .821 3.423 4.642 4.642 0 0 1-4.543 3.902z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.701 20.767-.958-1.348a2.975 2.975 0 0 0-1.655-5.443 2.97 2.97 0 0 0-1.55.437l-.896-1.383a4.692 4.692 0 0 1 2.445-.692c2.564 0 4.65 2.07 4.65 4.612 0 1.529-.76 2.955-2.036 3.817zM26.152 31.963c-.286 0-.573-.025-.853-.073l.299-1.614a3.178 3.178 0 0 0 1.63-.14c1.314-.473 2.135-1.723 2.004-3.04l1.674-.158c.206 2.063-1.064 4.011-3.092 4.74a5.005 5.005 0 0 1-1.662.285z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.717 33.917a4.835 4.835 0 0 1-2.402-.625l.84-1.42c.404.23.852.364 1.325.394 1.394.103 2.676-.698 3.118-1.954l1.587.534c-.653 1.845-2.458 3.07-4.468 3.07zM26.308 12.878a3.008 3.008 0 0 0-.834-1.377c-1.002-.953-2.515-1.135-3.678-.45l-.872-1.401c1.817-1.074 4.17-.79 5.72.68a4.639 4.639 0 0 1 1.282 2.117l-1.618.431zM14.608 28.322a4.653 4.653 0 0 1-4.55-3.914c-.404-2.513 1.332-4.873 3.859-5.256a4.653 4.653 0 0 1 4.275 1.596l-1.294 1.044a2.992 2.992 0 0 0-2.726-1.025 2.945 2.945 0 0 0-2.458 3.386 2.986 2.986 0 0 0 2.912 2.524l-.018 1.645z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.305 20.767a4.601 4.601 0 0 1-2.035-3.817c0-2.543 2.085-4.612 4.649-4.612.865 0 1.711.237 2.446.692l-.903 1.383a2.97 2.97 0 0 0-1.55-.437 2.975 2.975 0 0 0-1.655 5.443l-.952 1.348zM16.854 31.963c-.56 0-1.126-.097-1.661-.292-2.03-.728-3.305-2.676-3.093-4.739l1.674.158c-.13 1.317.69 2.573 2.004 3.04.522.188 1.089.237 1.63.14l.299 1.614a4.552 4.552 0 0 1-.853.079z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.29 33.917c-2.01 0-3.815-1.22-4.469-3.07l1.587-.535c.442 1.256 1.724 2.057 3.118 1.954.473-.036.921-.17 1.326-.394l.84 1.42a4.862 4.862 0 0 1-2.402.625zM16.699 12.878l-1.625-.43a4.638 4.638 0 0 1 1.283-2.119c1.549-1.474 3.901-1.753 5.719-.68l-.872 1.402c-1.163-.685-2.676-.497-3.678.45a3.073 3.073 0 0 0-.827 1.377z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.41 26.064c-1.276-.079-2.408-.825-2.956-1.954l1.07-.491a2.312 2.312 0 0 0 1.955 1.292l-.069 1.153z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.589 27.915h-1.183c0-1.881 1.569-3.41 3.498-3.41v1.153c-1.276 0-2.315 1.013-2.315 2.257z",
    fill: "#000"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v42H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainguide);
export default __webpack_public_path__ + "static/media/brainguide.9c840386.svg";
export { ForwardRef as ReactComponent };